import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get, pickBy } from 'lodash'
import { connect } from 'react-redux'
import { isValidAuthCode, refreshBlobAccess } from '../../../redux/modules/auth'

@connect(({ auth }) => ({
  authCode: get(auth, 'user.blobAccessAuthorizationCode')
}),
  { isValidAuthCode, refreshBlobAccess }
  )
class Image extends Component {
  static propTypes = {
    authCode: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    isValidAuthCode: PropTypes.func.isRequired,
    refreshBlobAccess: PropTypes.func.isRequired,
    isPublic: PropTypes.bool
  }

  static defaultProps = {
    src: '',
    isPublic: false
  }

  state = {
    isAuthCodeValid: false
  }

  async componentDidMount() {
    await this.initialize()
  }

  initialize = async() => {
    const { authCode, isPublic } = this.props

    if (isPublic) {
      this.setState({ isAuthCodeValid: true })
      return
    }

    await this.refreshBlobAccess(authCode)
  }

  refreshBlobAccess = async authCode => {
    const { body: isValid } = await this.props.isValidAuthCode(authCode)

    if (!isValid.value) {
      await this.props.refreshBlobAccess(authCode)
    }

    this.setState({ isAuthCodeValid: true })
  }

  render() {
    const { src, authCode, isPublic } = this.props

    const prefix = src.includes('?') ? '&' : '?'
    const newSrc = isPublic
      ? src
      : src + prefix + `authorizationCode=${authCode}`

    const newProps = {
      ...this.props,
      authCode: undefined,
      dispatch: undefined
    }

    return ((isPublic || this.state.isAuthCodeValid) && <img {...pickBy(newProps)} src={newSrc} />)
  }
}

export default Image
